export function RetrieveAccount() {
  return <div>Recuperar conta</div>;
}
